import Vue from '@/setup'

import { EVENT_CHAT_LOADED, EVENT_CHAT_OPEN } from '@/config/events'
import { LogHelper } from '@/helpers/Log'

const { $EventBus, $cobrowse } = Vue.prototype

export const UrlHelper = {
  react() {
    const start = window.location.hash.indexOf('?')
    const query = window.location.hash.substr(start)
    const params = new URLSearchParams(query)
    const open = params.get('open')

    if (open) {
      const components = open.split(',')
      components.forEach(component => {
        switch (component) {
          case 'cobrowsing':
            LogHelper.info('OPEN COBROWSING')

            $cobrowse.startConversation({
              cID: params.get('conversationID'),
              pin: params.get('pin'),
              reason: params.get('reason') ? parseInt(params.get('reason')) : null,
            })
            break

          case 'chat':
            LogHelper.info('OPEN CHAT')
            $EventBus.$on(EVENT_CHAT_LOADED, () => {
              $EventBus.$emit(EVENT_CHAT_OPEN, { behavior: 'passive' })
            })
            break

          default:
            LogHelper.warn(`UrlHelper can not open unknown option: ${component}`)
        }
      })
    }
  },
}
